import { useState, MouseEvent } from "react";
import { LucideIcon } from "lucide-react";

interface HoverCard3DProps {
  title: string;
  description: string;
  icon: LucideIcon;
  color: "primary" | "secondary" | "accent";
}

const HoverCard3D = ({ title, description, icon: Icon, color }: HoverCard3DProps) => {
  const [rotate, setRotate] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    
    const rotateX = ((y - centerY) / centerY) * -10;
    const rotateY = ((x - centerX) / centerX) * 10;
    
    setRotate({ x: rotateX, y: rotateY });
  };

  const handleMouseLeave = () => {
    setRotate({ x: 0, y: 0 });
  };

  return (
    <div
      className="cyber-card p-8 cursor-pointer transition-all duration-300 hover:shadow-2xl group"
      style={{
        transform: `perspective(1000px) rotateX(${rotate.x}deg) rotateY(${rotate.y}deg)`,
        transition: "transform 0.1s ease-out",
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className={`mb-6 p-4 rounded-sm border border-${color}/50 bg-${color}/10 w-fit group-hover:scale-110 transition-transform`}>
        <Icon className={`w-12 h-12 text-${color}`} />
      </div>
      <h3 className={`text-2xl font-cyber mb-3 text-${color}`}>{title}</h3>
      <p className="font-mono text-foreground/80">{description}</p>
    </div>
  );
};

export default HoverCard3D;
